// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2e15b5a2","977":"fab3fc67"}[chunkId] + ".chunk.js";
};